"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploader = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var theme_1 = require("./theme");
var Text_1 = require("./Text");
var UIComponents_1 = require("./UIComponents");
var nanoid_1 = require("nanoid");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
/**
 * An input that allows for uploading a file to the form. The file is hosted on the client's browser until a submission of the form is made.
 * @param {string} name - The field name, used as reference by formik.
 * @param {string} label - Label for this input, used to provide context to the user
 * @param {string=} description - Description for this input, used to provide context to the user
 * @param {string=} deleteName - Optional field name used to reference if the file should be deleted or not.
 * @param {boolean} [canDelete=true] - A parameter dictating whether or not to show the delete button and allow users to delete the existing file
 * @param {string=} accept - Optional parameter used to limit the types of files that can be uploaded for when the user clicks on the input. This does not limit the files that can be dragged into the space.
 * @param {FileProperties=} defaultFile - The initial file used to display or preview information to the user
 */
var FileUploader = function (_a) {
    var name = _a.name, deleteName = _a.deleteName, label = _a.label, description = _a.description, accept = _a.accept, _b = _a.canDelete, canDelete = _b === void 0 ? true : _b, defaultFile = _a.defaultFile, props = __rest(_a, ["name", "deleteName", "label", "description", "accept", "canDelete", "defaultFile"]);
    var _c = (0, formik_1.useField)(name), fileField = _c[0], fileMeta = _c[1], fileHelpers = _c[2];
    var randomDeleteFieldName = (0, react_1.useMemo)(function () { return (0, nanoid_1.nanoid)(); }, []); // Used if deleteName isnt provided
    var _d = (0, formik_1.useField)(deleteName ? deleteName : randomDeleteFieldName), deleteField = _d[0], _ = _d[1], deleteHelpers = _d[2];
    var validateField = (0, formik_1.useFormikContext)().validateField;
    var _e = (0, react_1.useState)(false), dragActive = _e[0], setDragActive = _e[1];
    // This variable allows us to store if there is a file that either already exists (as a default) or
    // has been updated.
    var _f = (0, react_1.useState)(undefined), filePreview = _f[0], setFilePreview = _f[1];
    var inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (deleteField.value) {
            // if we're going to delete the file, there will be no preview.
            setFilePreview(undefined);
        }
        else if (fileField.value) {
            // if a file has been uploaded, that is the one to show.
            setFilePreview({
                source: URL.createObjectURL(fileField.value),
                name: fileField.value.name,
                size: fileField.value.size,
            });
        }
        else {
            // Otherwise, no file has been uploaded, but we are not deleting the existing one so preview that
            setFilePreview(defaultFile);
        }
        validateField(name);
    }, [defaultFile, deleteField.value, fileField.value, name, validateField]);
    var handleChange = function (event) {
        if (event !== null && event.target.files.length === 1) {
            // Set the file value to the first file, and set isDeleting to false
            deleteHelpers.setValue(false);
            fileHelpers.setValue(event.target.files[0]);
        }
    };
    return (react_1.default.createElement(UIComponents_1.ui.Wrapper, __assign({}, props),
        react_1.default.createElement(UIComponents_1.ui.Label, { label: label, description: description }),
        react_1.default.createElement(FileUploaderDiv, { preview: !!filePreview, error: !!fileMeta.error, dragActive: dragActive, onDragEnter: function (e) {
                e.preventDefault();
                e.stopPropagation();
                setDragActive(true);
            }, onDragOver: function (e) {
                e.preventDefault();
                e.stopPropagation();
                setDragActive(true);
            }, onDragLeave: function (e) {
                e.preventDefault();
                e.stopPropagation();
                setDragActive(false);
            }, onDragEnd: function (e) {
                e.preventDefault();
                e.stopPropagation();
                setDragActive(false);
            }, onDrop: function (e) {
                e.preventDefault();
                e.stopPropagation();
                // A user drops a file into the space, we'll set our field to be that file.
                if (e.dataTransfer.files[0]) {
                    deleteHelpers.setValue(false);
                    fileHelpers.setValue(e.dataTransfer.files[0]);
                }
                setDragActive(false);
            }, onClick: function () { return inputRef.current && inputRef.current.click(); } },
            filePreview ? (fileMeta.error ? ( // Case 1: User has uploaded a file, but it runs into an error
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Text_1.Text, { variant: "uiSmall500", textAlign: "center" },
                    "Unable to upload ",
                    filePreview.name),
                react_1.default.createElement(Text_1.Text, { variant: "paragraphMedium", textAlign: "center", mt: "xxsmall", color: "gray600" },
                    react_1.default.createElement(Text_1.Text, { as: "u", variant: "uiSmall500", color: "gold400" }, "Try again"),
                    " ",
                    fileMeta.error))) : (
            // Case 2: User has either uploaded a file or there's a default file that exists, and the file hasnt been removed
            react_1.default.createElement(VerticallyCenteredRow, null,
                react_1.default.createElement(FilePreview, { alt: "", src: filePreview.source }),
                react_1.default.createElement(PreviewInfo, null,
                    react_1.default.createElement(Text_1.Text, { variant: "uiSmall500", mb: theme_1.theme.space.xxsmall, style: {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        } }, filePreview.name),
                    react_1.default.createElement(Text_1.Text, { variant: "paragraphMedium", color: "gray600" }, filePreview.size && filePreview.size > 0
                        ? humanReadableFileSize(filePreview.size)
                        : "Please Upload A File")),
                canDelete && (react_1.default.createElement(RemoveText, { variant: "uiSmall500", color: "red700", onClick: function (e) {
                        e.stopPropagation(); // Stop the outer div from being clicked
                        fileHelpers.setValue(undefined); // Clear value for the input
                        deleteHelpers.setValue(true); // Set isDeleting to true
                    } }, "Remove"))))) : (
            // Case 3: Either the image has been deleted, or there's no default image and nothing has been uploaded
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Text_1.Text, { variant: "uiSmall500", textAlign: "center" },
                    "Drop your file here, or",
                    " ",
                    react_1.default.createElement(Text_1.Text, { as: "u", variant: "uiSmall500", color: "gold400" }, "browse")),
                react_1.default.createElement(Text_1.Text, { variant: "paragraphMedium", textAlign: "center", mt: "xxsmall", color: "gold800" },
                    "Supported file types: ",
                    accept ? accept.split(',').join(", ") : "All"))),
            react_1.default.createElement("input", { style: { display: "none" }, ref: inputRef, type: "file", accept: accept, onChange: handleChange }))));
};
exports.FileUploader = FileUploader;
var humanReadableFileSize = function (size, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 2; }
    var units = ["B", "KB", "MB", "GB", "TB", "PB", "EB"];
    var power = Math.floor(Math.log10(size) / 3);
    if (power >= units.length)
        return "ERR";
    return "".concat(+(size / Math.pow(10, (power * 3))).toFixed(decimalPlaces)).concat(units[power]);
};
var FileUploaderDiv = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: ", ";\n  background: ", ";\n  border-radius: 8px;\n  padding: ", ";\n  cursor: pointer;\n"], ["\n  border: ", ";\n  background: ", ";\n  border-radius: 8px;\n  padding: ", ";\n  cursor: pointer;\n"])), function (props) {
    return props.dragActive
        ? "1px solid ".concat(theme_1.theme.colors.gold400)
        : props.error
            ? "2px solid ".concat(theme_1.theme.colors.red700)
            : props.preview
                ? "1px solid ".concat(theme_1.theme.colors.gray500)
                : "1px dashed ".concat(theme_1.theme.colors.gray500);
}, function (props) {
    return props.dragActive
        ? theme_1.theme.colors.gold000
        : props.error
            ? "#FFC7C23D"
            : theme_1.theme.colors.white;
}, function (props) {
    return props.preview ? theme_1.theme.space.small : theme_1.theme.space.medium;
});
var PreviewInfo = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: ", ";\n  max-width: 70%;\n"], ["\n  margin-left: ", ";\n  max-width: 70%;\n"])), theme_1.theme.space.xsmall);
var FilePreview = styled_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  object-fit: contain;\n  position: relative;\n  &::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    background-color: ", ";\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    inset: 0;\n  }\n  &::after {\n    content: \"\u2713\";\n    padding: 7px 12px;\n    display: block;\n    position: absolute;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    box-sizing: border-box;\n    inset: 0;\n  }\n"], ["\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  object-fit: contain;\n  position: relative;\n  &::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    background-color: ", ";\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    inset: 0;\n  }\n  &::after {\n    content: \"\u2713\";\n    padding: 7px 12px;\n    display: block;\n    position: absolute;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    box-sizing: border-box;\n    inset: 0;\n  }\n"])), theme_1.theme.colors.white, theme_1.theme.colors.white, theme_1.theme.colors.white, theme_1.theme.colors.gray400);
var RemoveText = (0, styled_1.default)(Text_1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  margin-left: auto;\n  padding-left: ", ";\n"], ["\n  cursor: pointer;\n  margin-left: auto;\n  padding-left: ", ";\n"])), theme_1.theme.space.medium);
var VerticallyCenteredRow = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
